// extracted by mini-css-extract-plugin
export default {"title":"Title_title__3b7oS","center":"Title_center__NA3MJ","sx":"Title_sx__0dito"};